module.exports = __webpack_public_path__ + "static/network-requests-8c3bccdab9d6789b2a42047707a140c1.png";